import axios from "axios";
import CryptoJS from "crypto-js";
import { baseUrl } from "../Constants/urlConfigs";
import { Constants } from "../Constants/Constants";

class APIService {
  login = (subscriberId, authentication) => {
    const osDetails = window.navigator.userAgent;

    const url = `${baseUrl}/recharge/cbapi/login`;
    const userId =
      subscriberId === undefined || subscriberId === null ? "" : subscriberId;

    let config;
    if (authentication) {
      config = {
        params: {
          bot: "tsbot",
          type: "Authenticated",
          user: userId,
          gethelpOs: osDetails,
          //src
        },
      };
    } else {
      if (subscriberId !== undefined && subscriberId !== "") {
        config = {
          params: {
            bot: "tsbot",
            type: "SemiAuthenticated",
            user: userId,
            authenticated: false,
            gethelpOs: osDetails,
            //src
          },
        };
      } else {
        config = {
          params: {
            bot: "tsbot",
            type: "Unauthenticated",
            authenticated: false,
            gethelpOs: osDetails,
            //src
          },
        };
      }
    }
    return axios.get(url, config);
  };

  getCoachingCount = (subscriberId) => {
    const url = `${baseUrl}/recharge/cbapi/CoachingCount`;
    const userId =
    subscriberId === undefined || subscriberId === null ? "" : subscriberId;

    const config = {
      params: {
        user: userId,
        bot: "tsbot",
      }
    };
    return axios.get(url, config);
  };

  storeAgentLogs = (datatoSent) => {
    const url = `${baseUrl}/recharge/cbapi/agentchathistory`;
    const bearerToken =
      Constants.env === "UAT"
        ? Constants.uatCoachScreenToken
        : Constants.prodCoachScreenToken;
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
    };
    return axios.post(url, datatoSent, config);
  };

  loginForLink = (subId, authenticated, action, jumpNode, src) => {
    const osDetails = window.navigator.userAgent;
    console.log("IN API 1");
    localStorage.setItem("linkLoginOnce", true);

    const url = `${baseUrl}/recharge/cbapi/login`;

    const timestamp = new Date().valueOf();
    const unencryptedSubID = subId + "-" + timestamp;
    let config;
    if (authenticated === "true" || authenticated === true) {
      config = {
        params: {
          bot: "tsbot",
          type: "Authenticated",
          user: subId,
          action: action,
          authenticated: authenticated,
          jumpNode: jumpNode,
          source: src,
          gethelpOs: osDetails,
        },
      };
    } else {
      if (subId !== undefined && subId !== "" && subId !== null) {
        config = {
          params: {
            bot: "tsbot",
            type: "SemiAuthenticated",
            user: subId,
            action: action,
            authenticated: false,
            jumpNode: jumpNode,
            source: src,
            gethelpOs: osDetails,
          },
        };
      } else {
        config = {
          params: {
            bot: "tsbot",
            type: "Unauthenticated",
            action: action,
            authenticated: false,
            jumpNode: jumpNode,
            source: src,
            gethelpOs: osDetails,
          },
        };
      }
    }

    console.log("login started", new Date().getUTCSeconds());
    return axios.get(url, config);
  };

  chatForLink = (token, refresh) => {
    const url = `${baseUrl}/recharge/cbapi/chat`;
    const bearerToken = localStorage.getItem("token");

    const params = {
      bot: "tsbot",
      input: null,
      token: token,
      refresh: refresh !== undefined || refresh !== null ? refresh : null,
    };

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };

    return axios.get(url, config);
  };

  feedbackCloseButton = (token, refresh) => {
    const url = `${baseUrl}/recharge/cbapi/feedbackclosechat`;
    const bearerToken = localStorage.getItem("token");
    const params = {
      bot: "tsbot",
      input: null,
      token: token,
      refresh: refresh !== undefined || refresh !== null ? refresh : null,
    };
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      // params: params,
    };
    return axios.get(url, config);
  };

  mypackRedirection = (url, name, value) => {
    const params = {
      name: name,
      value: value,
    };
    return axios.post(url, params);
  };

  loginCount = (subId, bearerToken) => {
    const url = `${baseUrl}/recharge/cbapi/loginCount`;
    const params = { bot: "tsbot", user: subId };
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };
    return axios.get(url, config);
  };

  chat = (data, input, textData) => {
    const url = `${baseUrl}/recharge/cbapi/chat`;
    const bearerToken = localStorage.getItem("token");
    // console.log("beareretoken", bearerToken);
    const params = input
      ? {
          bot: "tsbot",
          code: data,
          input: encodeURIComponent(JSON.stringify(input)),
        }
      : { bot: "tsbot", code: data, input: null };
    //  console.log(input,"HEREEEEE");

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };
    return axios.get(url, config);
  };
  chatWithTokenOnly = (token) => {
    const url = `${baseUrl}/recharge/cbapi/chat`;
    const bearerToken = token;
    const params = { bot: "tsbot", code: null, input: null };

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };
    return axios.get(url, config);
  };

  chatPost = (data, input) => {
    const url = `${baseUrl}/recharge/cbapi/chat`;
    const bearerToken = localStorage.getItem("token");
    // console.log("beareretoken", bearerToken);
    const params = input
      ? { bot: "tsbot", code: data }
      : { bot: "tsbot", code: data };
    //  console.log(input,params,"HEREEEEE");

    // params.input = encodeURIComponent(JSON.stringify(input));
    // input = encodeURIComponent(JSON.stringify(input));

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
      // input:input
    };
    // console.log("api-chat", "code-chat:", data);
    // console.log(config, "params", params);
    return axios.post(url, input, config);
  };

  chatPostPacks = (data, input) => {
    const url = `${baseUrl}/recharge/cbapi/chat`;
    const bearerToken = localStorage.getItem("token");
    // console.log("beareretoken", bearerToken);
    const params = input
      ? { bot: "tsbot", code: data }
      : { bot: "tsbot", code: data };

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
      // input:input
    };
    return axios.post(url, input, config);
  };

  initialState = () => {
    const url = `${baseUrl}/recharge/cbapi/chat`;
    const bearerToken = localStorage.getItem("token");
    // console.log("beareretoken", bearerToken);
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: { bot: "tsbot" },
    };
    // console.log("api-initial");
    return axios.get(url, config);
  };

  refreshChat = () => {
    const url = `${baseUrl}/recharge/cbapi/chat`;
    const bearerToken = localStorage.getItem("token");
    // console.log("beareretoken", bearerToken);
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: { bot: "tsbot", refresh: null },
    };
    // console.log("api-refresh");
    return axios.get(url, config);
  };

  refreshOnBackToMenu = () => {
    const url = `${baseUrl}/recharge/cbapi/chat`;
    const bearerToken = localStorage.getItem("token");
    // console.log("beareretoken", bearerToken);
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: { bot: "tsbot", refresh: null, input: null },
    };
    // console.log(config);
    return axios.get(url, config);
  };

  // post requests for messageredirect
  messageRedirect = (url, data) => {
    // const url="https://uat.help.tatasky.com/chatbot/tatasky/predirect";
    const bearerToken = localStorage.getItem("token");
    // console.log("beareretoken", bearerToken,url,data)
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
    };
    // console.log("api-redirect");
    return axios.post(url, data, config);
  };

  historyApi = (sessionId, source) => {
    const url = `${baseUrl}/recharge/cbapi/history`;
    const bearerToken = localStorage.getItem("token");
    // console.log("beareretoken", bearerToken, sessionId, source);
    const config = {
      headers: sessionId
        ? { Authorization: bearerToken }
        : { Authorization: `Bearer ${bearerToken}` },
      params: {
        bot: "tsbot",
        limit: "100",
        ascending: "true",
        sessionId: sessionId,
        source: source,
      },
    };
    console.log("api-historya");
    return axios.get(url, config);
  };

  uploadMedia = (data) => {
    const url = `${baseUrl}/recharge/cbapi/userupload`;
    const bearerToken = localStorage.getItem("token");
    // console.log("beareretoken", bearerToken, data);
    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
    };
    const formData = new FormData();
    formData.append("file", data);
    return axios.post(url, formData, config);
  };

  encryption = (subId) => {
    let salt = "random_salt";
    let password = "tsapi^1uat@23";

    let key256 = CryptoJS.PBKDF2(password, salt, {
      keySize: 256 / 32,
      iterations: 65536,
      hasher: CryptoJS.algo.SHA256.create(),
    });

    let iv = CryptoJS.enc.Base64.parse("hKhEwBqH8/mHfOKGcoaI1A==");
    let cipherText = CryptoJS.AES.encrypt(subId, key256, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: iv,
    });

    return cipherText.toString();
  };

  agentStatus = (SubscriberID, User, RMN, securitykey, source, sessionID) => {
    const url = `${baseUrl}/recharge/cbapi/chattoagentStatus`;
    const bearerToken = localStorage.getItem("token");
    const config = {
      headers: sessionID
        ? { Authorization: bearerToken }
        : { Authorization: `Bearer ${bearerToken}` },
      params: {
        SubscriberID: SubscriberID,
        User: User,
        RMN: RMN,
        datetime: new Date().getTime(),
        source: source,
        securitykey: securitykey,
      },
    };
    console.log("api-historya");
    return axios.get(url, config);
  };

  generateLitmusFeedback = async (userData) => {
    var urlToReturn = "";
    const url = Constants.litmusUrl;
    const data = userData;
    return axios.post(url, data);
  };

  //     // password: [C@6093dd95 salt: [B@5622fdf
  //     //     factory: javax.crypto.SecretKeyFactory@28ac3dc3  spec: javax.crypto.spec.PBEKeySpec@32eebfca tmp: com.sun.crypto.provider.PBKDF2KeyImpl@f00a69c9
  //     //     secret: javax.crypto.spec.SecretKeySpec@1736d cipher:  iv: [B@42607a4f cipherText: [B@782663d3
  //     //     3001167802-1616738616808
  //     //     YREB4NAF37J3cSmQSx0KX10LKqdxdkOY28b2L57iuP4
  //   // iruDPssGAJaHczJTuxjKylNYdQHfsIFFGcm41OQUzaY=
  //     // rDObm4a27xaoqFLagOLdQ44vgA0bBk0gua1D2LX/8qA=
  //    // const userid = '3001167802-'
  //     // const timestamp = new Date().valueOf();
  //     // const subid = userid+timestamp;
  //     // console.log("userid: ",userid, " timestamp: ", timestamp);
  //     // console.log("subid: ", subid);
  //      // const password = 'tsapi^1uat@23';
  //     const subid = '3001167802-1616900962499';
  //     const password = Object.assign([],"tsapi^1uat@23");
  //     const salt = "random_salt";
  //     var result = [];
  //     for (var i = 0; i < salt.length; i++) {
  //         result.push(salt.charCodeAt(i));
  //     }
  //   const nonceB64 = "hKhEwBqH8/mHfOKGcoaI1A==";

  //   console.log("passowrd: ",password,result);

  //     let res = pbkdf2("tsapi^1uat@23", salt, 65536, 256);
  //     console.log("res",res.toString());
  //     const iv = "000" + new Date().valueOf();
  //     const cipherText = CryptoJS.createCipheriv("aes", res.toString(), iv)
  //     CryptoJS.createCipheriv()
  //     console.log(btoa(cipherText));

  // const key = CryptoJS.PBKDF2(password,salt, { keySize: 256, iterations: 65536, hasher: CryptoJS.algo.SHA256})

  // console.log("key: ",key)

  // const salt = CryptoJS.enc.Hex.parse('random_salt');
  // const iv   = CryptoJS.enc.Hex.parse(nonceB64);
  // CryptoJS.lib.WordArray

  // alert("" + CryptoJS.lib.WordArray.random(16));
  // const salt = CryptoJS.enc.Utf8.parse("random_salt");
  // const iv   = CryptoJS.lib.WordArray.random(16);
  // const iv   =  window.btoa(nonceB64);
  // const iv   =  CryptoJS.enc.Utf8.parse(nonceB64);
  // alert(iv)
  // console.log("iv ", iv);

  // const key         = CryptoJS.PBKDF2(password, salt, { keySize: 256, iterations: 65536, hasher: CryptoJS.algo.SHA256});
  // const encrypted   = CryptoJS.AES.encrypt(subid, key, {iv: iv}).ciphertext;
  // const concatenned = CryptoJS.lib.WordArray.create().concat(salt).concat(iv).concat(encrypted)

  // console.log({
  // iv: iv.toString(CryptoJS.enc.Base64),
  // salt: salt.toString(CryptoJS.enc.Base64),
  // encrypted: encrypted.toString(CryptoJS.enc.Base64),
  // concatenned: concatenned.toString(CryptoJS.enc.Base64)
  // });
}

var apiService = new APIService();
export default apiService;

// password: [C@6093dd95 salt: [B@5622fdf
//     factory: javax.crypto.SecretKeyFactory@64f6106c  spec: javax.crypto.spec.PBEKeySpec@553a3d88 tmp: com.sun.crypto.provider.PBKDF2KeyImpl@f00a69c9
//     secret: javax.crypto.spec.SecretKeySpec@1736d cipher:  iv: [B@2de8284b cipherText: [B@396e2f39
//     3001167802-1616900962499
//     EzCCHyBg-TOXCNqlvcorfNOeEE6LM8tr3tx_G_0qH2w
